export default __webpack_public_path__ + "static/media/BaruLogo.96ba1fc9.svg";